import { useTranslation } from "react-i18next";
import { ScrollTop } from "primereact/scrolltop";
import DadosConsulta from '../resposta/DadosConsulta';
import EnderecoHist from '../resposta/EnderecoHist';
import HistoricoInfo from '../resposta/HistorioInfo';
import ListaConsulta from '../resposta/ListaConsulta';
import Empresas from '../resposta/Empresas';
import Acoes from '../resposta/Acoes';
import Score from '../resposta/Score';
import CCFS from "../resposta/CCFS";
import Apontamentos from "../resposta/Apontamentos";
import Cadastral from "../resposta/Cadastral";
import Informativo from "../resposta/Informativo";
import Protestos from "../resposta/Protestos";
import RendaPresumida from "../resposta/RendaPresumida";
import DadosConsultaPJ from "../resposta/DadosConsultaPJ";
import Socios from "../resposta/Socios";
import Aviso from "../resposta/Aviso";
import FaturamentoPresumido from "../resposta/FaturamentoPresumido";
import IndicadorPJ from "../resposta/IndicadorPJ";
import LimiteCreditoPJ from "../resposta/LimiteCreditoPJ";
import MaisNegocio from "../resposta/MaisNegocio";
import ScoreGrauAtvidadePJ from "../resposta/ScoreGrauAtividadePJ";
import ParticipacaoEmpresa from "../resposta/ParticipacaoEmpresa";
import ComportamentoFinanceiro from "../resposta/ComportamentoFinanceiro";
import LinhaCredito from "../resposta/LinhaCredito";
import Endividamento from "../resposta/Endividamento";
import PontualidadePagamento from "../resposta/PontualidadePagamento";
import HistoricoPagamento from "../resposta/HistoricoPagamento";
import ProtestoQuod from "../resposta/ProtestoQuod";
import IndicadorNegocio from "../resposta/IndicadorNegocio";
import HistoricoVencido from "../resposta/HistoricoVencido";
import RestricaoSilver from "../resposta/RestricaoSilver";
import SCPC from "../resposta/SCPC";
import RestricaoAvancadaScore from "../resposta/RestricaoAvancadaScore";
import { InformacaoInfoPositiva } from "../../../components/InfomacaoInfoPositiva";
import { InformacaoQuod } from "../../../components/InfomacaoQuod";
import GastoEstimadoPJ from "../resposta/GastoEstimadoPJ";
import ScoreInadimplenciaPJ from "../resposta/ScoreInadimplenciaPJ";
import AnaliseSetorial from "../resposta/AnaliseSetorial/AnaliseSetorial";
import { Sintegra } from "../resposta/Sintegra";
import { DevedorUniao } from "../resposta/DevedorUniao";
import Pendencias from "../resposta/Pendencias";
import { Gps894Page } from "../resposta/Gps894";
import { ProtestoCenprot } from "../resposta/ProtestoCenprot";
import { Gps895Page } from "../resposta/Gps895";
import { BacenScoreSCRPage } from "../resposta/BacenScoreSCR";
import RestricaoPalladium from "../resposta/RestricaoPalladium";
import { BacenScoreSCRSintetico } from "../resposta/BacenScoreSCRSintetico";
import { BacenScoreSCRAnalitico } from "../resposta/BacenScoreSCRAnalitico";
import { DividaAtiva } from "../resposta/DividaAtiva";
import { InstituicaoPagamento } from "../resposta/InstituicaoPagamento";
import AcoesCompleta from "../resposta/AcoesCompleta";
import { CadastralBacenScoreSCRPage } from "../resposta/CadastralBacenScoreSCR";
import PendenciaLN from "../resposta/PendenciaLN";
import PendenciaCompany from "../resposta/PedenciaCompany";
import GPS from "../resposta/GPS";
import PendenciaMercado from "../resposta/PendenciaMercado";
import CreditoPositivo from "./CreditoPositivo";
import { LaranjaChavePix } from "./LaranjaChavePix";
import { InstituicaoPagamentoSintetico } from "./InstituicaoPagamentoSintetico";
import CreditoPositivoPlus from "./CreditoPositivoPlus";
import AcoesCompletaMensagem from "./AcoesCompletaMensagem";
import SerasaRelatorio from "./SerasaRelatorio";
import { Panel } from "primereact/panel";
import NadaConsta from "../../../components/nadaConsta";
import RestricaoFullPF from "./RestricaoFullPF";
import RestricaoFullPJ from "./RestricaoFullPJ";
import ProtestoNacionalCpf from "./ProtestoNacionalCpf";
import ProtestoNacionalCnpj from "./ProtestoNacionalCnpj";
import { SerasaPremium, SpcSerasa } from "./SerasaConsultaAi";
import ProtestoCartorio, { temProtestoCartorio } from "./ProtestoCartorio";
import { ConsultaSCRPage, temDadosSCR } from "./ConsultaSCR/ConsultaSCR";

export default function RespostaInsumoPage({
  resposta,
}: {
  resposta: any;
}) {

  const { t } = useTranslation();

  function isSetorPublico(cnae?: string | null): boolean {
    if (!cnae) return false;
    // CNAEs do setor público pertencem à divisão 84 (Administração Pública)
    return cnae.trim().startsWith('84');
  }

  const setorPublico = isSetorPublico(resposta.dadosConsultaPJ?.cnae);

  return (
    <>


      <Informativo informativo={resposta.informativo}></Informativo>
      <br></br>
      {resposta.avisos.length > 0 && (
        <Aviso avisos={resposta.avisos}></Aviso>)}
      <br></br>

      {(resposta.dadosConsulta ||
        resposta.dadosConsultaPJ ||
        resposta.score ||
        resposta.scoreBoletoPJ ||
        resposta.acoes ||
        resposta.showApontamento ||
        (resposta.protestosQuod && resposta.protestosQuod.length > 0) ||
        (resposta.ccfs && resposta.ccfs.length > 0) ||
        resposta.rendaPresumida ||
        resposta.scoreGrauAtividadePJ ||
        resposta.comportamentoFinanceiro ||
        resposta.linhaCredito ||
        resposta.pontualidadePagamento ||
        resposta.historicoPagamento ||
        (resposta.endividamentos && resposta.endividamentos.length > 0) ||
        resposta.historicoVencido ||
        resposta.limiteCreditoPJ ||
        resposta.maisNegocio ||
        resposta.gastoEstimadoPJ ||
        resposta.faturamentosPresumido ||
        resposta.consulta ||
        resposta.scoreInadimplenciaPJ ||
        (resposta.empresas && resposta.empresas.length > 0) ||
        (resposta.socios && resposta.socios.length > 0) ||
        (resposta.participacoesEmpresa && resposta.participacoesEmpresa.length > 0) ||
        (resposta.enderecosHist && resposta.enderecosHist.length > 0) ||
        (resposta.emailsHist && resposta.emailsHist.length > 0) ||
        (resposta.conglomerados && resposta.conglomerados.length > 0) ||
        (resposta.calularesHist && resposta.calularesHist.length > 0) ||
        (resposta.telefonesHist && resposta.telefonesHist.length > 0) ||
        (resposta.analises && resposta.analises.length > 0) ||
        (resposta.indicadoresPJ && resposta.indicadoresPJ.length > 0) ||
        (resposta.indicadores && resposta.indicadores.length > 0)
      ) && (<InformacaoQuod></InformacaoQuod>)}
      {resposta.dadosConsulta && (
        <DadosConsulta dadosConsulta={resposta.dadosConsulta}></DadosConsulta>)}
      {resposta.dadosConsultaPJ && (
        <DadosConsultaPJ capitalSocial={resposta.capitalSocial} dadosConsultaPJ={resposta.dadosConsultaPJ}></DadosConsultaPJ>
      )}
      {resposta.pessoa && (
        <> <br></br><Cadastral pessoa={resposta.pessoa}></Cadastral></>

      )}

      {setorPublico && (
        <>
          <br></br>
          <div
            style={{
              backgroundColor: '#fff3cd',
              border: '1px solid #ffc107',
              borderRadius: '6px',
              padding: '1.5rem 2rem',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '0.75rem',
              color: '#856404',
              fontWeight: 700,
              fontSize: '1.4rem',
              textAlign: 'center',
            }}
          >
            <i className="pi pi-exclamation-triangle" style={{ fontSize: '2rem', color: '#ffc107' }}></i>
            <span>Empresa do setor público não tem score.</span>
          </div>
        </>
      )}
      {!setorPublico && resposta.score && (
        <>
          <br></br>
          <Score scoreBoleto={false} label="Score" score={resposta.score} ></Score>
        </>
      )}
      {!setorPublico && resposta.scoreBoletoPJ && (
        <>
          <br></br>
          <Score scoreBoleto={true} label="Score Boleto PJ" score={resposta.scoreBoletoPJ} ></Score>
        </>
      )}

      {resposta.acoes && (
        <>
          <br></br>
          <Acoes acoes={resposta.acoes} ></Acoes>
        </>
      )}

      {resposta.showApontamento && (
        <>
          <br></br>
          <Apontamentos apontamentos={resposta.apontamentos} ></Apontamentos>
        </>
      )}
      {resposta.protestosQuod && (
        <>
          <br></br>
          <ProtestoQuod protestos={resposta.protestosQuod} ></ProtestoQuod>
        </>
      )}

      {resposta.ccfs && (
        <>
          <br></br>
          <CCFS ccfs={resposta.ccfs} ></CCFS>
        </>
      )}
      {resposta.rendaPresumida && (
        <>
          <br></br>
          <RendaPresumida rendaPresumida={resposta.rendaPresumida} ></RendaPresumida>
        </>
      )}
      {resposta.scoreGrauAtividadePJ && (
        <>
          <br></br>
          <ScoreGrauAtvidadePJ scoreGrauAtividadePJ={resposta.scoreGrauAtividadePJ} ></ScoreGrauAtvidadePJ>
        </>
      )}
      {resposta.scoreInadimplenciaPJ && (
        <>
          <br></br>
          <ScoreInadimplenciaPJ
            scoreInadimplenciaPJ={resposta.scoreInadimplenciaPJ}
          ></ScoreInadimplenciaPJ>
        </>
      )}
      {resposta.comportamentoFinanceiro && (
        <>
          <br></br>
          <ComportamentoFinanceiro comportamento={resposta.comportamentoFinanceiro} ></ComportamentoFinanceiro>
        </>
      )}
      {resposta.linhaCredito && (
        <>
          <br></br>
          <LinhaCredito linhaCredito={resposta.linhaCredito} ></LinhaCredito>
        </>
      )}
      {resposta.endividamentos && resposta.endividamentos.length > 0 && (
        <>
          <br></br>
          <Endividamento endividamentos={resposta.endividamentos} ></Endividamento>
        </>
      )}
      {resposta.pontualidadePagamento && (
        <>
          <br></br>
          <PontualidadePagamento pontualidadePagamento={resposta.pontualidadePagamento} ></PontualidadePagamento>
        </>
      )}
      {resposta.historicoPagamento && (
        <>
          <br></br>
          <HistoricoPagamento historicoPagamento={resposta.historicoPagamento} ></HistoricoPagamento>
        </>
      )}
      {resposta.historicoVencido && (
        <>
          <br></br>
          <HistoricoVencido
            historicoVencido={resposta.historicoVencido}
          ></HistoricoVencido>
        </>
      )}
      {resposta.limiteCreditoPJ && (
        <>
          <br></br>
          <LimiteCreditoPJ limiteCreditoPJ={resposta.limiteCreditoPJ} ></LimiteCreditoPJ>
        </>
      )}
      {resposta.gastoEstimadoPJ && (
        <>
          <br></br>
          <GastoEstimadoPJ
            gastoEstimadoPJ={resposta.gastoEstimadoPJ}
          ></GastoEstimadoPJ>
        </>
      )}
      {resposta.maisNegocio && (
        <>
          <br></br>
          <MaisNegocio maisNegocio={resposta.maisNegocio} ></MaisNegocio>
        </>
      )}
      {resposta.faturamentosPresumido && (
        <>
          <br></br>
          <FaturamentoPresumido faturamentos={resposta.faturamentosPresumido} ></FaturamentoPresumido>
        </>
      )}
      {resposta.consulta && (
        <>
          <br></br>
          <ListaConsulta consulta={resposta.consulta} ></ListaConsulta>
        </>
      )}
      {resposta.empresas && resposta.empresas.length > 0 && (
        <>
          <br></br>
          <Empresas empresas={resposta.empresas} ></Empresas>
        </>
      )}
      {resposta.socios && resposta.socios.length > 0 && (
        <>
          <br></br>
          <Socios showRestricao={resposta.showApontamento} socios={resposta.socios} ></Socios>
        </>
      )}
      {resposta.participacoesEmpresa && resposta.participacoesEmpresa.length > 0 && (
        <>
          <br></br>
          <ParticipacaoEmpresa showRestricao={resposta.showApontamento} participacoes={resposta.participacoesEmpresa} ></ParticipacaoEmpresa>
        </>
      )}
      {resposta.enderecosHist && resposta.enderecosHist.length > 0 && (
        <>
          <br></br>
          <EnderecoHist enderecos={resposta.enderecosHist} ></EnderecoHist>
        </>
      )}
      {resposta.emailsHist && resposta.emailsHist.length > 0 && (
        <>
          <br></br>
          <HistoricoInfo showHist={true} label={t('email')} historicos={resposta.emailsHist} ></HistoricoInfo>
        </>
      )}
      {resposta.conglomerados && resposta.conglomerados.length > 0 && (
        <>
          <br></br>
          <HistoricoInfo showHist={false} label={t('conglomerados')} historicos={resposta.conglomerados} ></HistoricoInfo>
        </>
      )}
      {resposta.calularesHist && resposta.calularesHist.length > 0 && (
        <>
          <br></br>
          <HistoricoInfo showHist={true} label={t('celular')} historicos={resposta.calularesHist} ></HistoricoInfo>
        </>
      )}
      {resposta.telefonesHist && resposta.telefonesHist.length > 0 && (
        <>
          <br></br>
          <HistoricoInfo showHist={true} label={t('fone')} historicos={resposta.telefonesHist} ></HistoricoInfo>
        </>
      )}
      {resposta.analises && resposta.analises.length > 0 && (
        <>
          <br></br>
          <AnaliseSetorial analises={resposta.analises} ></AnaliseSetorial>
        </>
      )}
      {resposta.indicadoresPJ && resposta.indicadoresPJ.length > 0 && (
        <>
          <br></br>
          <IndicadorPJ indicadores={resposta.indicadoresPJ}></IndicadorPJ> </>)}
      {resposta.indicadores && resposta.indicadores.length > 0 && (
        <>
          <br></br>
          <IndicadorNegocio indicadores={resposta.indicadores}></IndicadorNegocio> </>)}
      {(resposta.showProtesto ||
        resposta.restricaoSilver ||
        resposta.restricaoPalladium ||
        resposta.restricaoAvancadaScore ||
        resposta.scpc ||
        resposta.pendencia ||
        resposta.protestoCentroProt ||
        resposta.gps894 ||
        resposta.gps895 ||
        resposta.sintegra ||
        resposta.cadastralSrcBacenScorePositivo ||
        resposta.srcSintetico ||
        resposta.srcBacenScorePositivo ||
        resposta.dividaAtiva ||
        resposta.pendenciaLN ||
        resposta.instituicaoPagamento ||
        resposta.acoesCompleta ||
        resposta.gps ||
        resposta.instituicaoPagamentoSintetico ||
        resposta.laranjaChavePix ||
        resposta.pendenciaMercado ||
        resposta.pendenciaCompany ||
        resposta.restricaoFullPf ||
        resposta.restricaoFullPj ||
        resposta.protestoNacionalCpf ||
        resposta.protestoNacionalCnpj ||
        resposta.creditoCompletoScore ||
        resposta.creditoBasicoPlus ||
        resposta.protestoCartorio ||
        resposta.protestoCartorioRegional ||
        resposta.scrSeletor ||
        resposta.creditoPositivo ||
        resposta.serasaRelatorioPf ||
        resposta.serasaRelatorioPj ||
        resposta.pgfn)
        && (<InformacaoInfoPositiva></InformacaoInfoPositiva>)}
      {resposta.showProtesto && (
        <>
          <br></br>
          <Protestos cartorios={resposta.cartorios} ></Protestos>
        </>
      )}
      {resposta.restricaoSilver && (
        <>
          <br></br>
          <RestricaoSilver restricaoSilver={resposta.restricaoSilver} ></RestricaoSilver>
        </>
      )}
      {resposta.restricaoPalladium && (
        <>
          <br></br>
          <RestricaoPalladium restricaoPalladium={resposta.restricaoPalladium} ></RestricaoPalladium>
        </>
      )}
      {resposta.restricaoAvancadaScore && (
        <>
          <br></br>
          <RestricaoAvancadaScore restricaoAvancadaScore={resposta.restricaoAvancadaScore} ></RestricaoAvancadaScore>
        </>
      )}
      {resposta.restricaoFullPf && (
        <>
          <br></br>
          <RestricaoFullPF restricaoFullPf={resposta.restricaoFullPf} ></RestricaoFullPF>
        </>
      )}
      {resposta.restricaoFullPj && (
        <>
          <br></br>
          <RestricaoFullPJ restricaoFullPj={resposta.restricaoFullPj} ></RestricaoFullPJ>
        </>
      )}
      {resposta.protestoNacionalCpf && (
        <>
          <br></br>
          {resposta.protestoNacionalCpf.protestos?.length > 0 ? (
            <ProtestoNacionalCpf data={resposta.protestoNacionalCpf} ></ProtestoNacionalCpf>
          ) : (
            <Panel header={t('protestoNacionalCpf')}><NadaConsta /></Panel>
          )}
        </>
      )}
      {resposta.protestoNacionalCnpj && (
        <>
          <br></br>
          {resposta.protestoNacionalCnpj.protestos?.length > 0 ? (
            <ProtestoNacionalCnpj data={resposta.protestoNacionalCnpj} ></ProtestoNacionalCnpj>
          ) : (
            <Panel header={t('protestoNacionalCnpj')}><NadaConsta /></Panel>
          )}
        </>
      )}
      {resposta.creditoCompletoScore && (
        <>
          <br></br>
          <SerasaPremium data={resposta.creditoCompletoScore} ></SerasaPremium>
        </>
      )}
      {resposta.creditoBasicoPlus && (
        <>
          <br></br>
          <SpcSerasa data={resposta.creditoBasicoPlus} ></SpcSerasa>
        </>
      )}
      {resposta.protestoCartorio && (
        <>
          <br></br>
          {temProtestoCartorio(resposta.protestoCartorio) ? (
            <ProtestoCartorio title={t('protestoCartorio')} data={resposta.protestoCartorio} ></ProtestoCartorio>
          ) : (
            <Panel header={t('protestoCartorio')}><NadaConsta /></Panel>
          )}
        </>
      )}
      {resposta.protestoCartorioRegional && (
        <>
          <br></br>
          {temProtestoCartorio(resposta.protestoCartorioRegional) ? (
            <ProtestoCartorio title={t('protestoCartorioRegional')} data={resposta.protestoCartorioRegional} ></ProtestoCartorio>
          ) : (
            <Panel header={t('protestoCartorioRegional')}><NadaConsta /></Panel>
          )}
        </>
      )}
      {resposta.scrSeletor && (
        <>
          <br></br>
          {temDadosSCR(resposta) ? (
            <ConsultaSCRPage {...resposta} />
          ) : (
            <Panel header={t('scrSeletor')}><NadaConsta /></Panel>
          )}
        </>
      )}
      {resposta.scpc && (
        <>
          <br></br>
          <SCPC scpc={resposta.scpc} ></SCPC>
        </>
      )}
      {resposta.sintegra && (
        <>
          <br></br>
          <Sintegra data={resposta.sintegra} />
        </>
      )}
      {resposta.pgfn && (
        <>
          <br></br>
          <DevedorUniao data={resposta.pgfn} />
        </>
      )}
      {resposta.pendencia && (
        <>
          <br></br>
          <Pendencias pendenciaCompany={resposta.pendencia} ></Pendencias>
        </>
      )}
      {resposta.protestoCentroProt && Object.getOwnPropertyNames(resposta.protestoCentroProt).length && (
        <>
          <br></br>
          <ProtestoCenprot data={resposta.protestoCentroProt} ></ProtestoCenprot>
        </>
      )}
      {resposta.gps894 && Object.getOwnPropertyNames(resposta.gps894).length > 0 && (
        <>
          {" "}
          <br></br>
          <Gps894Page {...resposta.gps894} />
        </>
      )}

      {resposta.gps895 && Object.getOwnPropertyNames(resposta.gps895).length > 0 && (
        <>
          {" "}
          <br></br>
          <Gps895Page {...resposta.gps895} />
        </>
      )}
      {resposta.cadastralSrcBacenScorePositivo && (
        <>
          {" "}
          <br></br>
          <CadastralBacenScoreSCRPage {...resposta.cadastralSrcBacenScorePositivo} />
        </>
      )}
      {resposta.srcBacenScorePositivo && (
        <>
          {" "}
          <br></br>
          <BacenScoreSCRPage {...resposta.srcBacenScorePositivo} />
        </>
      )}

      {resposta.acoesCompletaMensagem && (
        <>
          <br></br>
          <AcoesCompletaMensagem mensagem={resposta.acoesCompletaMensagem}></AcoesCompletaMensagem>
        </>
      )}

      {resposta.srcSintetico && (
        <>
          {" "}
          <br></br>
          <BacenScoreSCRSintetico {...resposta.srcSintetico} />
        </>
      )}
      {resposta.srcAnalitico && (
        <>
          {" "}
          <br></br>
          <BacenScoreSCRAnalitico {...resposta.srcAnalitico} />
        </>
      )}
      {resposta.dividaAtiva && (
        <>
          {" "}
          <br></br>
          <DividaAtiva dividaAtiva={resposta.dividaAtiva} />
        </>
      )}
      {resposta.instituicaoPagamento && (
        <>
          {" "}
          <br></br>
          <InstituicaoPagamento {...resposta.instituicaoPagamento} />
        </>
      )}
      {resposta.instituicaoPagamentoSintetico && (
        <>
          {" "}
          <br></br>
          <InstituicaoPagamentoSintetico {...resposta.instituicaoPagamentoSintetico} />
        </>
      )}
      {resposta.laranjaChavePix && (
        <>
          {" "}
          <br></br>
          <LaranjaChavePix laranjaChavePix={resposta.laranjaChavePix} />
        </>
      )}
      {resposta.acoesCompleta && resposta.acoesCompleta.length > 0 && (
        <>
          <br></br>
          <AcoesCompleta acoes={resposta.acoesCompleta}></AcoesCompleta>
        </>
      )}
      {resposta.pendenciaLN && (
        <>
          {" "}
          <br></br>
          <PendenciaLN pendenciaLN={resposta.pendenciaLN} />
        </>
      )}
      {resposta.pendenciaCompany && (
        <>
          <br></br>
          <PendenciaCompany
            pendenciaCompany={resposta.pendenciaCompany}
          ></PendenciaCompany>
        </>
      )}
      {resposta.gps && (
        <>
          {" "}
          <br></br>
          <GPS gps={resposta.gps} />
        </>
      )}
      {resposta.pendenciaMercado && (
        <>
          {" "}
          <br></br>
          <PendenciaMercado pendenciaMercado={resposta.pendenciaMercado} />
        </>
      )}
      {resposta.creditoPositivo && (
        <>
          {" "}
          <br></br>
          <CreditoPositivo creditoPositivo={resposta.creditoPositivo} />
        </>
      )}
      {resposta.creditoPositivoPlus && (
        <>
          {" "}
          <br></br>
          <CreditoPositivoPlus creditoPositivo={resposta.creditoPositivoPlus} />
        </>
      )}
      {resposta.serasaRelatorioPf && (
        <>
          {" "}
          <br></br>
          {resposta.serasaRelatorioPf.vazio ? (
            <Panel header="Serasa Relatório PF">
              <NadaConsta></NadaConsta>
            </Panel>
          ) : (
            <SerasaRelatorio relatorio={resposta.serasaRelatorioPf} titulo="Serasa Relatório PF" />
          )}
        </>
      )}
      {resposta.serasaRelatorioPj && (
        <>
          {" "}
          <br></br>
          {resposta.serasaRelatorioPj.vazio ? (
            <Panel header="Serasa Relatório PJ">
              <NadaConsta></NadaConsta>
            </Panel>
          ) : (
            <SerasaRelatorio relatorio={resposta.serasaRelatorioPj} titulo="Serasa Relatório PJ" />
          )}
        </>
      )}
      <br></br>
      <br></br>

      <ScrollTop
        style={{ marginBottom: "5rem" }}
        className="border-round bg-primary"
        icon="pi pi-arrow-up text-base"
      />
    </>
  );
}
